import React from 'react';
import './SearchPhotoStrip.css';

export interface SearchPhoto {
  publicId?: string;
  url: string;
  src?: string;
  srcset?: string;
  width?: number;
  height?: number;
  alt: string;
  caption?: string;
  galleryId?: string;
}

export interface SearchPhotoBootstrap {
  kind?: string;
  slug?: string;
  searchPhotos?: SearchPhoto[];
  shareImage?: { url?: string; alt?: string; publicId?: string } | null;
}

export function readSearchBootstrap(kind: string, slug?: string): SearchPhotoBootstrap | null {
  if (typeof document === 'undefined') return null;
  const node = document.getElementById('page-bootstrap');
  if (!node?.textContent) return null;
  try {
    const data = JSON.parse(node.textContent) as SearchPhotoBootstrap;
    if (data?.kind !== kind || !Array.isArray(data.searchPhotos)) return null;
    if (slug && data.slug !== slug) return null;
    return data;
  } catch (error) {
    return null;
  }
}

interface SearchPhotoStripProps {
  photos?: SearchPhoto[];
  label?: string;
}

const SearchPhotoStrip: React.FC<SearchPhotoStripProps> = ({ photos = [], label = 'Recent photography' }) => {
  const visible = photos.filter((photo) => photo && (photo.src || photo.url) && photo.alt);
  if (!visible.length) return null;
  return (
    <section className="home-search-photos" aria-label={label}>
      {visible.map((photo, index) => {
        const src = photo.src || photo.url;
        const width = photo.width && photo.width > 0 ? photo.width : 1200;
        const height = photo.height && photo.height > 0 ? photo.height : 800;
        return (
          <figure key={`${photo.galleryId || ''}-${src}`}>
            <img
              src={src}
              srcSet={photo.srcset || undefined}
              sizes="(min-width: 900px) 20vw, 70vw"
              alt={photo.alt}
              width={width}
              height={height}
              loading={index === 0 ? 'eager' : 'lazy'}
              fetchPriority={index === 0 ? 'high' : undefined}
              decoding={index === 0 ? 'auto' : 'async'}
              style={{ aspectRatio: `${width} / ${height}` }}
            />
            {photo.caption ? <figcaption>{photo.caption}</figcaption> : null}
          </figure>
        );
      })}
    </section>
  );
};

export default SearchPhotoStrip;
